import axios from 'axios';
import {
  Message
} from 'element-ui';

const service = axios.create({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8', 'Access-Control-Allow-Origin': '*', 
    'Cache-Control': 'no-cache,no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  },
    withCredentials: true,
  timeout: 10000,
});

service.interceptors.request.use(config => {
  config.headers.token = 'token';
  return config;
});

service.interceptors.response.use((response) => {
  if (response.status == 200) {
    const res = response.data;
    return res;
  } else {
    Message.error('Network error. ' + response.status);
    return;
  }
}, () => {
  Message.error('Network error. ');
});

export default service;



// WEBPACK FOOTER //
// ./src/assets/js/axios/interceptor.js